'use client'

import useScreenSize from '@/src/hooks/useScreenSize'
import { useEffect, useState } from 'react'
import { useScroll } from '../../global/ScrollContext'
import { cx } from '@/src/styles/stylebook'

const GlobalScrollContainer = ({
  children,
  threshold = 105,
  afterScrollClassName = '',
  beforeScrollClassName = '',
  className = '',
}: {
  children: React.ReactNode
  threshold?: number
  afterScrollClassName?: string
  beforeScrollClassName?: string
  className?: string
}) => {
  const { scrollY } = useScroll()
  const [afterScroll, setAfterScroll] = useState(false)

  useEffect(() => {
    setAfterScroll(scrollY > threshold)
  }, [scrollY])

  return (
    <div className={cx(afterScroll ? afterScrollClassName : beforeScrollClassName, className)}>
      {children}
    </div>
  )
}

export default GlobalScrollContainer
